import { FC, useRef } from "react"

import { Table } from "antd"
import { NavLink } from "react-router-dom"

import {
  DriverAddForm,
  DriverAddFormProps
} from "@/components/Drivers/DriverAddForm"

import { TransportAddForm, TransportAddFormProps } from "../TransportAddForm"

import { IDriver } from "@/types/IDriver"
import { ITranportPairOrder } from "@/types/IOrder"

import { paths } from "@/router/paths"

import { formatDriver, formatTransport } from "@/utils/formatString"

export interface TransportTableProps {
  transports: ITranportPairOrder[] | undefined
  orderDate?: Date
  additionalColumns?: any[]
  isDespetcher?: boolean
}

export const TransportTable: FC<TransportTableProps> = (props) => {
  const { transports, additionalColumns, orderDate, isDespetcher } = props

  const driverComponent = useRef<DriverAddFormProps>(null)
  const transportComponent = useRef<TransportAddFormProps>(null)

  const transportColumns = [
    {
      title: "Водитель",
      dataIndex: ["driver"],
      key: "driver",
      render: (_: any, transportPair: ITranportPairOrder) => 
        processDriver(transportPair.driver),
      isVisible: true,
      order: 1
    },
    {
      title: "Транспорт",
      dataIndex: ["truck"],
      key: "truck",
      render: (_: any, transportPair: ITranportPairOrder) => 
        formatTransport(transportPair.truck),
      isVisible: true,
      order: 2
    },
    {
      title: "Период загрузки ",
      dataIndex: ["timeUnloadFuel"],
      key: "timeUnloadFuel",
      render: (_: any, transportPair: ITranportPairOrder) => transportPair.wishTimeSlot ? 
      `${orderDate?.toLocaleDateString()} ${transportPair.wishTimeSlot}` : "-",
      isVisible: !isDespetcher,
      order: 3
    }
  ]

  const processDriver = (driver?: IDriver) => {
    if (driver?.id) {
      return (
        <NavLink 
          key={"driver" + driver.id} 
          to={paths.driverById(driver.id)}
        >
          {formatDriver(driver)}
        </NavLink>
      )
    }
  }

  return (
    <>
      <DriverAddForm ref={driverComponent}></DriverAddForm>
      <TransportAddForm ref={transportComponent}></TransportAddForm>
      <Table
        columns={[...transportColumns.filter(c=>c.isVisible), ...(additionalColumns ?? [])]}
        pagination={false}
        rowKey={(transport) => transport.id}
        expandable={{
          expandedRowRender: (transportPair) => formatTransport(transportPair.pickup),
          rowExpandable: (transport) =>
            transport.pickup != undefined && transport.pickup != null,
          defaultExpandAllRows: true
        }}
        dataSource={transports}
      />
    </>
  )
}
